/* eslint-disable no-console */

const isProduction = process.env.NODE_ENV === "production";

const log = (message, ...args) => {
  if (!isProduction) console.log(message, args);
};

const error = (message, err) => {
  if (!isProduction) console.error(message, err);
};

const logger = { log, error };

export default logger;
